import React, { useEffect, useReducer } from 'react';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
// import {  useParams } from 'react-router';

import { useNavigate, useParams, Link, useLocation } from 'react-router-dom';

import { competitionService } from './competitionService';
import { ShowSelector } from '../show';
import { DisciplineSelector } from '../discipline';
import { FormObjectList } from '../common';
import { HorseSelector } from '../horse';
import { useAuth } from '../auth/Authcontext';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'

const statusOptions = [
    'Open',
    'Closed',
    'Ranked'
]

const ribbonOptions = [
    'None',
    'First',
    'Second',
    'Third'
]

const initialState = {
    isLoading: true,
    isSubmitting: false,
    isEditting: false,
    competition: undefined,
}

const ACTIONS = {
    COMPETITION_GET_CALL: 'COMPETITION_GET_CALL',
    COMPETITION_GET_SUCCESS: 'COMPETITION_GET_SUCCESS',
    COMPETITION_GET_ERROR: 'COMPETITION_GET_ERROR',
    TOGGLE_EDIT: 'TOGGLE_EDIT',
    COMPETITION_UPDATE_CALL: 'COMPETITION_UPDATE_CALL',
    COMPETITION_UPDATE_SUCCESS: 'COMPETITION_UPDATE_SUCCESS',
    COMPETITION_UPDATE_ERROR: 'COMPETITION_UPDATE_ERROR'
}

function reducer(state, action) {
    switch (action.type) {

        case ACTIONS.COMPETITION_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: true,
            }
        case ACTIONS.COMPETITION_GET_CALL:
            return {
                ...state,
                isLoading: true
            }
        case ACTIONS.COMPETITION_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                competition: {
                    ...action.data
                }
            }
        case ACTIONS.TOGGLE_EDIT:
            let isEditting = !state.isEditting
            return {
                ...state,
                isEditting: isEditting
            }
        case ACTIONS.COMPETITION_UPDATE_CALL:
            return {
                ...state,
                isSubmitting: true,
                isLoading: true
            }
        case ACTIONS.COMPETITION_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: false,
                competition: {
                    ...action.data
                }
            }
        default:
            throw new Error(`No action of type ${action.type} found in reducer.`)
    }
}

export default function InputResult() {
    const { contextValue } = useAuth();

    // const { competitionId } = useParams();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { register, handleSubmit, control, reset, formState: { errors } } = useForm();
    const { fields, append, remove } = useFieldArray({ control, name: 'competition.horses' });
    // const history = useHistory();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const competitionId = queryParams.get("competetionid");



    useEffect(() => {
        dispatch({ type: ACTIONS.COMPETITION_GET_CALL });
        competitionService.getCompetition(competitionId)
            .then(response => dispatch({ type: ACTIONS.COMPETITION_GET_SUCCESS, data: response.data }))
            .catch(error => console.error(error));
    }, [competitionId]);

    useEffect(() => {
        if (state.competition || !state.isEditting) {
            reset({ competition: state.competition });
        }
    }, [state.competition, state.isEditting, reset]);

    function handleEditClick(event) {
        event.preventDefault();
        dispatch({ type: ACTIONS.TOGGLE_EDIT });
    }

    function handleDeleteClick(event) {
        event.preventDefault();
        // if (window.confirm(`This will permanently delete the record for ${state.competition.name}, and any asscoiated records such as scores and ranks. There is no way to undo this action. Press 'Ok' if you are sure you want to delete ${state.competition.name}.`)) {
        //     competitionService.deleteCompetition(competitionId);
        //     window.alert(`${state.competition.name} has been deleted.`);
        //     navigate('/competition');
        // }


        const message = `This will permanently delete the record for ${state.competition.name}, and any asscoiated records such as scores and ranks. There is no way to undo this action.`

        Swal.fire({
            title: 'Are you sure?',
            text: message,
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            heightAuto: false
        }).then((result) => {
            if (result.isConfirmed) {

                contextValue.showLoader();
                contextValue.updateLoaderText("Deleting competition...");

                competitionService.deleteCompetition(competitionId).then(response => {
                    toast.success(`${state.competition.name} has been deleted.`);
                    navigate('/competition');
                })
                    .catch(error => {
                        console.error(error);
                        toast.error("Error deleting competition");
                    })
                    .finally(() => contextValue.hideLoader());

                // delete logic here
            }
        });
    }

    function handleSaveClick({ competition }) {

        let horses = competition.horses.map((item) => {
            return {
                ...item,
                horseId: item.horse.id
                // horse: item.id
            }
        });

        // console.log(horses)
        // return
        contextValue.showLoader();
        contextValue.updateLoaderText("Updating competition...");

        competitionService.updateInputResult(competitionId, {
            horseResults: horses
        })
            .then(response => {


                console.log(response)
                toast.success("Competition updated successfully");
                navigate('/competition/' + competitionId);

            })
            .catch(error => {

                console.log(error.response.data);
                dispatch({ type: ACTIONS.COMPETITION_UPDATE_ERROR });

                if (error.response.data.isError) {
                    const message = error.response.data.messages.map(value => value).join("\n");
                    toast.error(message);

                } else {
                    toast.error("Error updating competition");
                }


                dispatch({ type: ACTIONS.COMPETITION_UPDATE_ERROR, data: error.response.data })
            })
            .finally(() => contextValue.hideLoader());



    }

    function handleNewCompetitionHorseClick(event) {
        event.preventDefault();
        append({
            horse: undefined,
            backNumber: 0,
        });
    }

    function renderStatusOptions() {
        return statusOptions.map((item) => (
            <option key={`status${item}`} value={item}>{item}</option>
        ));
    }

    function renderRibbonOptions() {
        return ribbonOptions.map((item) => (
            <option key={`ribbon${item}`} value={item}>{item}</option>
        ));
    }

    function renderCompetitionHorse(index) {
        return (
            <div className='card mb-3'>
                <div className="card-body row">
                    <div className="col">
                        <div className="row mb-3">
                            <div className="col">
                                <label htmlFor={`horse${index}`} className="form-label">Horse:</label>
                                <Controller
                                    control={control}
                                    name={`competition.horses[${index}].horse`}
                                    render={({ field: { onChange, value } }) => (
                                        <HorseSelector className='form-control' id={`horse${index}`} value={value} onChange={onChange} disabled={true} />
                                    )}
                                />
                            </div>
                            <div className="col">
                                <label htmlFor={`backNumber${index}`} className="form-label">Back Number:</label>
                                <input type='text' className='form-control' id={`backNumber${index}`} {...register(`competition.horses[${index}].backNumber`)} disabled={true} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col">
                                <label htmlFor={`place${index}`} className="form-label">Place:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id={`place${index}`}
                                    autoComplete="off"
                                    {...register(`competition.horses.${index}.place`, {
                                        required: { value: true, message: "Place is required" },
                                    })}
                                />
                                {errors?.competition?.horses?.[index]?.place && (
                                    <span className="text-danger">
                                        {errors.competition.horses[index].place.message}
                                    </span>
                                )}
                            </div>
                            <div className="col">
                                <label htmlFor={`ribbon${index}`} className="form-label">Ribbon:</label>
                                <select className='form-select' id={`ribbon${index}`} {...register(`competition.horses[${index}].ribbon`)} disabled={false}>
                                    {renderRibbonOptions()}
                                </select>
                            </div>
                            <div className="col opacity-0">
                                <label htmlFor={`points${index}`} className="form-label">Points:</label>
                                <input type='text' value={0} className='form-control' id={`points${index}`} autoComplete='off' {...register(`competition.horses[${index}].points`)} disabled={!state.isEditting} />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    return (
        <div className='container h-100 overflow-auto'>
            {!state.isLoading &&
                <form>
                    <div className="row mb-3">
                        <h2 className='col'>{state.competition.name}</h2>

                        <div className='col-auto'>
                            <button type='submit' className='btn btn-success text-white me-2' onClick={handleSubmit(handleSaveClick)}>Save</button>
                            <Link to={'/competition/' + competitionId} className='btn btn-primary ms-2'>Cancel</Link>

                        </div>

                    </div>

                    <FormObjectList
                        objectCount={fields.length}
                        objects={fields}
                        keyExtractor={(index) => fields[index].id}
                        render={renderCompetitionHorse}
                    />
                </form>
            }
        </div>
    );
}

